import {
  CardCvvElement,
  CardMonthElement,
  CardNumberElement,
  CardYearElement
} from "@recurly/react-recurly";
import React from "react";

const RecurlyFields = () => (
  <React.Fragment>
    <div className="card-number-container">
      <label>
        Credit Card Number*
        <br />
        <CardNumberElement
          className="billing-field"
          id="number"
        />
      </label>
    </div>
    <div className="card-info-container">
      <label>
        Month*
        <br />
        <CardMonthElement
          className="billing-field"
          id="month"
        />
      </label>
      <label>
        Year*
        <br />
        <CardYearElement
          className="billing-field"
          id="year"
        />
      </label>
      <label>
        ZIP*
        <br />
        <input
          className="billing-field"
          data-recurly="postal_code"
          id="postal_code"
        />
      </label>
      <label>
        CVV*
        <br />
        <CardCvvElement
          className="billing-field"
        />
      </label>
    </div>
  </React.Fragment>
);

export default RecurlyFields;
